var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutliner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#7E3FE4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_46229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 11.0002H25.1667C25.3877 11.0002 25.5996 10.9124 25.7559 10.7561C25.9122 10.5998 26 10.3878 26 10.1668C26 9.94581 25.9122 9.73385 25.7559 9.57757C25.5996 9.42129 25.3877 9.3335 25.1667 9.3335H6.83333C6.61232 9.3335 6.40036 9.42129 6.24408 9.57757C6.0878 9.73385 6 9.94581 6 10.1668C6 10.3878 6.0878 10.5998 6.24408 10.7561C6.40036 10.9124 6.61232 11.0002 6.83333 11.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 15.1667H18.5C18.721 15.1667 18.933 15.0789 19.0893 14.9226C19.2455 14.7663 19.3333 14.5543 19.3333 14.3333C19.3333 14.1123 19.2455 13.9004 19.0893 13.7441C18.933 13.5878 18.721 13.5 18.5 13.5H6.83333C6.61232 13.5 6.40036 13.5878 6.24408 13.7441C6.0878 13.9004 6 14.1123 6 14.3333C6 14.5543 6.0878 14.7663 6.24408 14.9226C6.40036 15.0789 6.61232 15.1667 6.83333 15.1667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.8335H6.83333C6.61232 21.8335 6.40036 21.9213 6.24408 22.0776C6.0878 22.2339 6 22.4458 6 22.6668C6 22.8878 6.0878 23.0998 6.24408 23.2561C6.40036 23.4124 6.61232 23.5002 6.83333 23.5002H18.5C18.721 23.5002 18.933 23.4124 19.0893 23.2561C19.2455 23.0998 19.3333 22.8878 19.3333 22.6668C19.3333 22.4458 19.2455 22.2339 19.0893 22.0776C18.933 21.9213 18.721 21.8335 18.5 21.8335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1667 17.6665H6.83333C6.61232 17.6665 6.40036 17.7543 6.24408 17.9106C6.0878 18.0669 6 18.2788 6 18.4998C6 18.7209 6.0878 18.9328 6.24408 19.0891C6.40036 19.2454 6.61232 19.3332 6.83333 19.3332H25.1667C25.3877 19.3332 25.5996 19.2454 25.7559 19.0891C25.9122 18.9328 26 18.7209 26 18.4998C26 18.2788 25.9122 18.0669 25.7559 17.9106C25.5996 17.7543 25.3877 17.6665 25.1667 17.6665Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_46229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutliner);
export default __webpack_public_path__ + "static/media/outliner.3b44b6efd1db4c8f1bab59102a2bcab9.svg";
export { ForwardRef as ReactComponent };